import React from "react";
import { UICheckbox } from "ui";
import { useAppDispatch, useAppSelector } from "../../../../hooks/ReduxHooks";
import {
  removeActiveFilters,
  setActiveFilters,
} from "../../../../store/slices/PagePaginagionSlice";
import { SEARCH_PARAMS } from "../../../../constants/consts";
import { t } from "i18next";

interface searchByCheckboxProps {
  filterItem: string;
}

export const SearchByCheckbox = (props: searchByCheckboxProps) => {
  const { filterItem } = props;
  const { activeFilters } = useAppSelector((state) => state.page);
  const dispatch = useAppDispatch();
  const isChecked = activeFilters.includes(filterItem);

  const handleOnChange = () => {
    if (isChecked) {
      dispatch(removeActiveFilters(filterItem));
      return;
    }

    dispatch(setActiveFilters(filterItem));
  };

  return (
    <label className="catalogControlAnt__optionRow">
      <UICheckbox
        checked={isChecked}
        onChange={handleOnChange}
        className="catalogControlAnt__optionCheckbox"
      />
      <span className="catalogControlAnt__optionLabel">
        {t(SEARCH_PARAMS[filterItem])}
      </span>
    </label>
  );
};
